// extracted by css-extract-rspack-plugin
var _1 = "JEqjLGt4a_QwdS3l";
export { _1 as "header" }
// extracted by css-extract-rspack-plugin
var _1 = "JEqjLGt4a_QwdS3l";
export { _1 as "header" }
